// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image[data-v-06731c7f]{height:100%}.image[data-v-06731c7f] img{min-height:auto}.content-right[data-v-06731c7f]{flex-direction:row}.content-left[data-v-06731c7f]{flex-direction:row-reverse}@media(max-width:991px){.content-bottom[data-v-06731c7f]{flex-direction:column-reverse}.content-top[data-v-06731c7f]{flex-direction:column}}.video[data-v-06731c7f]{height:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
